__turbopack_context__.v({
  "component": "style-module-scss-module__87K_wq__component",
  "currency-icon": "style-module-scss-module__87K_wq__currency-icon",
  "error": "style-module-scss-module__87K_wq__error",
  "error-message": "style-module-scss-module__87K_wq__error-message",
  "error-message-with-label": "style-module-scss-module__87K_wq__error-message-with-label",
  "eye": "style-module-scss-module__87K_wq__eye",
  "hidden": "style-module-scss-module__87K_wq__hidden",
  "inline-label": "style-module-scss-module__87K_wq__inline-label",
  "input-container": "style-module-scss-module__87K_wq__input-container",
});
